"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _qs = _interopRequireDefault(require("qs"));

function getParamsForUnified(sort) {
  var _ref, _queryParameters$page;

  var searchQuery = typeof window !== 'undefined' ? window.location.search : '';

  var queryParameters = _qs.default.parse(searchQuery, {
    ignoreQueryPrefix: true
  });

  var filters = (_ref = queryParameters.filters) !== null && _ref !== void 0 ? _ref : {};
  var filterKeys = Object.keys(filters);
  filterKeys = filterKeys.filter(function (key) {
    return filters[key] !== null;
  });
  var requestFilters = filterKeys.reduce(function (newFilters, key) {
    // @ts-expect-error
    newFilters[key] = filters[key];
    return newFilters;
  }, {});
  var params = {
    page: Number((_queryParameters$page = queryParameters.page) !== null && _queryParameters$page !== void 0 ? _queryParameters$page : 1),
    filters: requestFilters
  };

  if (sort) {
    params.sort = sort;
  }

  return params;
}

var _default = getParamsForUnified;
exports.default = _default;